<template>
  <thead>
    <tr>
      <th
        v-if="renderActionColumn"
        :class="[$style.tableHeader, $style.headerSpacer]"
      />
      <th
        v-for="(column, columnIndex) in columns"
        :key="columnIndex"
        :class="[
          $style.tableHeader,
          column.hasTooltip ? $style.tableHeaderWithTooltip : '',
        ]"
        @click="$emit('headerClick', column)"
      >
        <a
          v-if="column.sortBy"
          :class="sortableHeaderClass(column)"
        >
          {{ column.name }}
        </a>
        <label v-else>
          {{ column.name }}
        </label>
        <TooltipIcon
          v-if="column.hasTooltip"
          :class="$style.tooltip"
          icon="info"
          :orientation="hasOrientation(column)"
          :text="column.tooltipText"
        />
      </th>
    </tr>
  </thead>
</template>

<script>
import {
  TooltipIcon,
} from '@jumpcloud/ui-components';
import Util from 'client/util/Util';

export default {
  name: 'TableHeader',

  components: {
    TooltipIcon,
  },

  props: {
    columns: {
      type: Array,
      default() { return []; },
      // TODO: Add custom validator to verify the _format_ of the columns prop when not empty!
    },
    renderActionColumn: {
      type: Boolean,
      default: false,
    },
    sortBy: {
      type: String,
      default: '',
    },
  },

  methods: {
    hasOrientation(column) {
      return column.orientation || 'bottom';
    },
    sortableHeaderClass(column) {
      const classes = [this.$style.sortableHeader];

      // See if table is being sorted by this column
      if (column.sortBy) {
        if (this.sortBy === column.sortBy) {
          classes.push(this.$style.sortableHeaderActiveAsc);
        } else if (this.sortBy === Util.reverseSortBy(column.sortBy)) {
          classes.push(this.$style.sortableHeaderActiveDesc);
        }
      }

      return classes;
    },
  },
};
</script>
<style module>
@value (jcGrey600) from '~css/brand-colors.css';
@value (gradientLight6) from '~css/colors.css';
@value (itemTableStickyHeaderZIndex) from '~css/z-index.css';

.tableHeader {
  background-color: white;
  border-bottom: 1px solid gradientLight6;
  box-shadow: 0 1px rgba(0, 0, 0, 0.05);
  padding: 10px 10px 2px !important;
  position: sticky;
  top: 0;
  z-index: 2;
}

.tableHeaderWithTooltip {
  z-index: 2;
}

.headerSpacer {
  z-index: itemTableStickyHeaderZIndex;
}

.sortableHeader {
  color: jcGrey600 !important; /* overriding .jcux2 > a legacy styles */
  cursor: pointer;
}

.sortableHeader:hover { text-decoration: none !important; }

.sortableHeaderActiveAsc::after,
.sortableHeaderActiveDesc::after {
  font-family: 'jumpcloud', sans-serif !important;
  line-height: 11px;
  margin-left: 2px;
  position: relative;
}

.sortableHeaderActiveAsc::after {
  content: '\f0de';
  top: 4px;
}

.sortableHeaderActiveDesc::after {
  bottom: 2px;
  content: '\f0dd';
}

.tooltip.tooltip.tooltip {
  font-weight: normal;
  z-index: tooltipOverlayZIndex;
}

</style>
